var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { LoadingButton } from '../../../shared';
import i18n from 'i18next';
import { ShiftFlowModalContentTypes } from '../../ShiftFlowModalTypes';
import { styledWithTheme } from '@amzn/atoz-web';
export var getButtons = function (_a) {
    var dropNowIsSubmitting = _a.dropNowIsSubmitting, onClickDropNow = _a.onClickDropNow, setModalContent = _a.setModalContent, showBackButton = _a.showBackButton;
    var buttons = [];
    if (showBackButton) {
        buttons.push(React.createElement(StyledButton, { key: "shift_management_features_MultipleDropShiftModal_back_button", onClick: function () {
                setModalContent(ShiftFlowModalContentTypes.dropMultipleShifts);
            }, "aria-label": i18n.t('shift_management_features_MultipleDropShiftModal_back_button_text'), "alt-text": i18n.t('shift_management_common_button', {
                label: i18n.t('shift_management_features_MultiplseDropShiftModal_back_button_text')
            }), variant: ButtonVariant.Secondary, dataTestId: 'merged-shift-back-button' }, i18n.t('shift_management_features_MultipleDropShiftModal_back_button_text')));
    }
    buttons.push(React.createElement(LoadingButton, { loading: dropNowIsSubmitting, key: "shift_management_features_MultipleDropShiftModal_confrim_button", onClick: onClickDropNow, ariaLabel: i18n.t('shift_management_features_MultipleDropShiftModal_confrim_button_text'), altText: i18n.t('shift_management_common_button', {
            label: i18n.t('shift_management_features_MultipleDropShiftModal_confrim_button_text')
        }), buttonVariant: ButtonVariant.Primary, buttonText: i18n.t('shift_management_features_MultipleDropShiftModal_confrim_button_text'), width: '100%', dataTestId: 'merged-shift-confirm-drop-button' }));
    return buttons;
};
var StyledButton = styledWithTheme(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var templateObject_1;
